// extracted by mini-css-extract-plugin
export var scrollArea = "_qx-0";